import axios from "../../axios";

export const GetPremium = async (premiunUID) => {
	const payload = {
		premiunUID,
	};
	try {
		const response = await axios.post(
			"/api/Hospicash/Premium/GetPremium",
			payload
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			console.log("API Error:", error.response.data);
			throw new Error(error.response.data.message || "Login Failed");
		} else {
			throw new Error("Network error or server unreachable");
		}
	}
};
